import {Component, OnInit} from "@angular/core";
import {UserProfileSummaryEntityModel} from "../user-profile-summary-entity.model";
import {AuthService, provideEntityModel} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {CustomerSupportMessagingService} from "../../customer-support-messaging/customer-support-messaging.service";
import {AnalyticsService} from "../../analytics/analytics.service";
import {AnalyticEvent} from "../../analytics/analytic-event";

@Component({
    selector: "wbo-user-profile-chrome-control",
    templateUrl: "./user-profile-chrome-control.component.html",
    styleUrls: ["./user-profile-chrome-control.component.scss"],
    providers: [provideEntityModel(UserProfileSummaryEntityModel)]
})
export class UserProfileChromeControlComponent implements OnInit {

    constructor(public profileModel: UserProfileSummaryEntityModel,
                private authService: AuthService,
                private router: Router,
                private messagingService: CustomerSupportMessagingService,
                private analyticsService: AnalyticsService) {
    }

    ngOnInit() {
        this.profileModel.loadEntity(undefined).then(() => this.messagingService.updateUserDetails(this.profileModel.data));
    }

    logout() {
        this.analyticsService.trackEvent(AnalyticEvent.USER_LOGOUT);
        this.authService.logout();
        this.router.navigate(["/login"]);
    }

    profileClicked() {
        this.analyticsService.trackEvent(AnalyticEvent.HEADER_PROFILE);
    }
}
